export interface SlipsLabels {
  tabOutLabel: string
  tabInLabel: string
  issueButtonTitle: string
  receiveButtonTitle: string
  entryTagRecv: string
  entryTagIssu: string
  tabBarBgColor: string
  tabBarTextColor: string
  paymentButtonTitle: string
  paymentDialogTitle: string
  paymentTypeReceivedLabel: string
  paymentTypeRefundedLabel: string
  paymentTypeReceiveTdsLabel: string
}

const DEFAULT_TAB_BAR_COLOR = '#2e5a88'
const DEFAULT_TAB_BAR_TEXT_COLOR = 'white'
const ITEMS_TAKEN_TAB_BAR_COLOR = DEFAULT_TAB_BAR_COLOR
const ITEMS_TAKEN_TAB_BAR_TEXT_COLOR = DEFAULT_TAB_BAR_TEXT_COLOR

export function getSlipsLabels(accountType: string | undefined): SlipsLabels {
  const isItemsTaken = accountType === 'ITEMS_TAKEN'
  return {
    tabOutLabel: isItemsTaken ? 'IN' : 'OUT',
    tabInLabel: isItemsTaken ? 'OUT' : 'IN',
    issueButtonTitle: isItemsTaken ? 'Hire' : 'Issue',
    receiveButtonTitle: isItemsTaken ? 'Return' : 'Receive',
    entryTagRecv: isItemsTaken ? 'RETN' : 'RECV',
    entryTagIssu: isItemsTaken ? 'HIRE' : 'ISSU',
    tabBarBgColor: isItemsTaken ? ITEMS_TAKEN_TAB_BAR_COLOR : DEFAULT_TAB_BAR_COLOR,
    tabBarTextColor: isItemsTaken ? ITEMS_TAKEN_TAB_BAR_TEXT_COLOR : DEFAULT_TAB_BAR_TEXT_COLOR,
    paymentButtonTitle: isItemsTaken ? 'Make Payment' : 'Receive Payment',
    paymentDialogTitle: isItemsTaken ? 'Make Payment' : 'Receive Payment',
    paymentTypeReceivedLabel: isItemsTaken ? 'Pay' : 'Received',
    paymentTypeRefundedLabel: isItemsTaken ? 'Collect Refund' : 'Refunded',
    paymentTypeReceiveTdsLabel: 'Receive + TDS',
  }
}
